import { firebaseAuth, initRollbar } from '@mp';
import {
  ConfigurationProvider,
  FirebaseProvider,
  AnalyticsProvider,
  ToastProvider,
} from '@medely/ui-kit';
import App from 'App';
import ErrorBoundary from 'core/containers/ErrorBoundary';
import moment from 'moment-timezone';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import config from '@src/config';
import ChatGPTPixel from './components/ChatGPTPixel';

window.moment = moment;

const container = document.getElementById('root');
const root = createRoot(container as Element);

initRollbar({
  accessToken: config.rollbar.postClientItemKey,
  environment:
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_STAGING === 'true'
        ? 'staging'
        : 'production'
      : '',
});

root.render(
  <BrowserRouter>
    <ChatGPTPixel />
    <ErrorBoundary>
      <ToastProvider>
        <SnackbarProvider
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          hideIconVariant
          maxSnack={3}
        >
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <AnalyticsProvider
              writeKey={config.segmentWriteKey as string}
              sessionCreatePayload={{
                context: 'Professional Session',
                action: 'Started',
                session_access_type: 'web',
              }}
            >
              {/* @ts-ignore */}
              <ConfigurationProvider configuration={config}>
                <FirebaseProvider auth={firebaseAuth}>
                  <App />
                </FirebaseProvider>
              </ConfigurationProvider>
            </AnalyticsProvider>
          </QueryParamProvider>
        </SnackbarProvider>
      </ToastProvider>
    </ErrorBoundary>
  </BrowserRouter>,
);
